import { PolymerElement, html } from '@polymer/polymer/polymer-element';
import '../../elements/katapult-elements/katapult-icon.js';

class widgetLibraryCard extends PolymerElement {
  static get template() {
    return html`
      <style>
        :host {
          position: relative;
        }
        .addIcon {
          border-radius: 999px; /*makes icon a circle */
          height: 24px;
          width: 24px;
          background-color: #007299;
          z-index: 2;
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          text-align: center; /*horizontally centers the plus '+' */
          color: #fff;
          user-select: none;
          -webkit-user-select: none; /* Safari */
          cursor: pointer;
        }
        .addCard {
          border-radius: 16px;
          height: 125px;
          width: 125px;
          display: inline-flex;
          flex-direction: column;
          box-shadow: 0 0 8px rgba(0 0 0 / 32%);
          justify-content: flex-start; /* align along main axis */
          text-align: center;
          background-color: #fff;
          user-select: none;
          -webkit-user-select: none; /* Safari */
          margin: 8px 0 0 8px;
        }
        .iconBox {
          display: flex;
          justify-content: center;
          margin-top: 20px;
          margin-bottom: 10px;
        }
        .iconWrapper {
          border-radius: 999px;
          background-color: #ff8300;
          height: 45px;
          width: 45px;
          /* for centering iron-icon */
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .label {
          font-size: 14px;
          padding: 4px;
        }
        iron-icon {
          color: #fff;
          /* for centering inside .iconWrapper */
          margin-top: 10px;
        }
      </style>
      <!-- add icon -->
      <material-icon class="addIcon" icon="add" on-click="fireAddWidgetEvent"></material-icon>
      <!-- card -->
      <div class="addCard">
        <div class="iconBox">
          <div class="iconWrapper"><katapult-icon icon="[[icon]]" color="white" inferType></katapult-icon></div>
        </div>
        <div class="label">[[widgetLabel]]</div>
      </div>
    `;
  }

  static get properties() {
    return {
      icon: String,
      widgetLabel: String,
      widgetName: String
    };
  }

  ready() {
    super.ready();
  }

  fireAddWidgetEvent() {
    this.dispatchEvent(new CustomEvent('add-widget-clicked', { detail: { widget: this.widgetName }, bubbles: true }));
  }
}

window.customElements.define('widget-library-card', widgetLibraryCard);
